import { useState } from 'react';
import { Icon } from '../components/Icon';
import { FAQ } from '../content/site';

export function Faq() {
  // First item open by default; one panel at a time keeps the section compact.
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="section bg-surface-alt">
      <div className="container-content">
        <div className="mx-auto max-w-2xl text-center">
          <span className="eyebrow">Before you apply</span>
          <h2 className="mt-4 font-heading text-3xl font-bold text-ink-900 sm:text-4xl">
            Questions corporate partners ask
          </h2>
          <p className="mt-4 text-lg text-ink-500">
            Straight answers on how sponsoring a skill-based prize works, what it costs,
            and what you get back.
          </p>
        </div>

        <ul className="mx-auto mt-12 max-w-3xl space-y-4">
          {FAQ.map((item, i) => {
            const isOpen = openIndex === i;
            const panelId = `faq-panel-${i}`;
            const buttonId = `faq-button-${i}`;
            return (
              <li
                key={item.question}
                className="overflow-hidden rounded-2xl border border-line bg-white shadow-card"
              >
                <h3>
                  <button
                    id={buttonId}
                    type="button"
                    aria-expanded={isOpen}
                    aria-controls={panelId}
                    onClick={() => setOpenIndex(isOpen ? -1 : i)}
                    className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-5 text-left font-heading text-base font-semibold text-ink-900 transition-colors hover:text-primary-700 sm:px-6 sm:text-lg"
                  >
                    <span>{item.question}</span>
                    <span
                      className={`grid h-8 w-8 shrink-0 place-items-center rounded-full bg-aurora-soft text-primary-700 transition-transform duration-200 ${
                        isOpen ? 'rotate-45' : ''
                      }`}
                    >
                      <Icon name="arrow-right" className="h-4 w-4 -rotate-45" aria-hidden />
                    </span>
                  </button>
                </h3>
                <div
                  id={panelId}
                  role="region"
                  aria-labelledby={buttonId}
                  hidden={!isOpen}
                  className="px-5 pb-5 sm:px-6 sm:pb-6"
                >
                  <p className="text-sm leading-relaxed text-ink-700 sm:text-base">{item.answer}</p>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}

export default Faq;
